'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import type { VideoProps } from '@/components/videoGallery/VideoProps';
const Video = dynamic(() => import('@/components/videoGallery/Video'), { ssr: false });

const VideoWrapper = (props: VideoProps) => {
  return <Video {...props} />;
};

export default VideoWrapper;
